import { DIRECT_PLUGIN, PLUGIN_OPERATIONS } from '@openedx/frontend-plugin-framework';
import { getConfig } from '@edx/frontend-platform';

const config = {
  pluginSlots: {
    footer_slot: {
      plugins: [
        {
          // Hide the default footer
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents',
        },
        {
          // Insert a custom footer
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'custom_footer',
            type: DIRECT_PLUGIN,
            RenderWidget: () => (
              <div class="container-xl py-2 d-flex align-items-center">
                <div class="flex-grow-1">
                  <span class="d-block x-small">
                    {getConfig().SITE_NAME}. All rights reserved except where noted. edX, Open edX and their respective logos are registered trademarks of edX Inc.
                  </span>
                  <span class="d-block m-0">
                    <span class="pr-2 x-small">
                      <a href={`${getConfig().LMS_BASE_URL}/tos_and_honor`}>{_('Terms of Service & Honor Code')}</a>
                    </span>
                    <span class="pl-2 x-small">
                      <a href={`${getConfig().LMS_BASE_URL}/privacy`}>{_('Privacy Policy')}</a>
                    </span>
                  </span>
                </div>
                <a href="https://open.edx.org">
                  <img src="https://logos.openedx.org/open-edx-logo-tag.png" alt="Powered by Open edX" width="175" />
                </a>
              </div>
            ),
          },
        },
      ]
    }
  },
}

export default config;
